import * as z from "zod";
import { vm } from "../../../../shared/utils/validationMessages";
import type { AgeClassification } from "../../../../api/client/types/age-classification.types";
import type { Swimmer } from "../../../../api/client/types/swimmer.types";
import type { SwimmerBatchItem } from "../../../../api/client/types/swimmer.types";

export interface UseRegisterSwimmerFormProps {
  onSubmit: (data: SwimmerBatchItem[]) => void;
  ageClassifications: AgeClassification[];
  initialSwimmer?: Swimmer | null;
}

export const swimmerItemSchema = z.object({
  name: z.string().min(1, { message: vm.NAME_REQUIRED }),
  building_tower: z.string().min(1, { message: vm.TOWER_REQUIRED }),
  building_apartment: z.string().min(1, { message: vm.APARTMENT_REQUIRED }),
  age_classification_id: z
    .string()
    .min(1, { message: vm.AGE_CLASSIFICATION_REQUIRED }),
  swimmer_type_id: z.string().min(1, { message: vm.SWIMMER_TYPE_REQUIRED }),
  responsibleIdx: z.string().optional(),
});

export const formSchema = z.object({
  swimmers: z
    .array(swimmerItemSchema)
    .min(1, { message: vm.SWIMMERS_MIN_REQUIRED })
    .max(10, { message: vm.SWIMMERS_MAX_REQUIRED }),
});

export type FormSchema = z.infer<typeof formSchema>;
export type SwimmerItemSchema = z.infer<typeof swimmerItemSchema>;
